import React from 'react';
import { View, StyleSheet } from 'react-native';
import Skeleton from '../common/Skeleton';

const ListItemSkeleton: React.FC = () => {
  return (
    <View style={styles.container}>
      <Skeleton width={48} height={48} borderRadius={24} />
      <View style={styles.content}>
        <Skeleton width="60%" height={16} borderRadius={4} />
        <Skeleton width="40%" height={12} borderRadius={4} style={{ marginTop: 6 }} />
      </View>
      <Skeleton width={60} height={28} borderRadius={14} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: 16,
  },
  content: {
    flex: 1,
    marginLeft: 12,
  },
});

export default ListItemSkeleton;
